'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const global = css`
  :global() {
    @font-face {
      font-family: 'Proxima Nova';
      src: url('./fonts/proxima-nova-thin.woff2') format('woff2');
      font-weight: 100 300;
      font-display: optimal;
    }
    @font-face {
      font-family: 'Proxima Nova';
      src: url('./fonts/proxima-nova-regular.woff2') format('woff2');
      font-weight: 400 500;
      font-display: optimal;
    }
    @font-face {
      font-family: 'Proxima Nova';
      src: url('./fonts/proxima-nova-semibold.woff2') format('woff2');
      font-weight: 600;
      font-display: optimal;
    }
    @font-face {
      font-family: 'Proxima Nova';
      src: url('./fonts/proxima-nova-bold.woff2') format('woff2');
      font-weight: 700 800;
      font-display: optimal;
    }
    @font-face {
      font-family: 'Proxima Nova';
      src: url('./fonts/proxima-nova-extrabold.woff2') format('woff2');
      font-weight: 900;
      font-display: optimal;
    }

    *,
    *:before,
    *:after {
      box-sizing: border-box;
      border-width: 0;
      border-style: solid;
      border-color: transparent;
      outline-color: ${theme.colors.peoople['azul-electrico']};
    }

    *:focus-visible {
    }

    html {
      font-family: 'Proxima Nova', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol' !important;
      ${theme.typographies.default}
      color: ${theme.colors.neutral[1]};
    }

    body {
    }
    .hide {
      display: none !important;
    }
  }
`;
